import { createActions, createReducer } from 'reduxsauce';

// ✅ ACTION TYPES + CREATORS
const { Types, Creators } = createActions(
  {
    // Payment Methods
    getPaymentMethods: [],
    getPaymentMethodsRequest: [],
    getPaymentMethodsSuccess: ['response'],
    getPaymentMethodsFailure: ['error'],

    // Subscription
    subscribe: ['payload'],
    subscribeRequest: [],
    subscribeSuccess: ['response'],
    subscribeFailure: ['error'],

    // Checkout
    checkout: ['payload'],
    checkoutRequest: [],
    checkoutSuccess: ['response'],
    checkoutFailure: ['error'],

    // Promo Code
    validatePromoCode: ['payload'],        // Triggers the Saga
    validatePromoCodeRequest: [],
    validatePromoCodeSuccess: ['response'],
    validatePromoCodeFailure: ['error'],
    clearPromoCode: [],                    // Resets promo code state
  },
  { prefix: 'cb/payment/' }
);

// ✅ INITIAL STATE
export const INITIAL_STATE = {
  paymentMethods: [],
  promoCode: {
    data: null,       // { discount, code, ... } from backend
    isValid: false,
  },
  loading: {
    subscribe: false,
    checkout: false,
    paymentMethods: false,
    promoCode: false,
  },
  error: {
    subscribe: null,
    checkout: null,
    paymentMethods: null,
    promoCode: null,
  },
};

// ✅ REDUCER HANDLERS
export const HANDLERS = {

  // PAYMENT METHODS
  [Types.GET_PAYMENT_METHODS_REQUEST]: (state) => ({
    ...state,
    loading: { ...state.loading, paymentMethods: true },
    error: { ...state.error, paymentMethods: null },
  }),
  [Types.GET_PAYMENT_METHODS_SUCCESS]: (state, { response }) => ({
    ...state,
    paymentMethods: response,
    loading: { ...state.loading, paymentMethods: false },
  }),
  [Types.GET_PAYMENT_METHODS_FAILURE]: (state, { error }) => ({
    ...state,
    loading: { ...state.loading, paymentMethods: false },
    error: { ...state.error, paymentMethods: error },
  }),

  // SUBSCRIPTION
  [Types.SUBSCRIBE_REQUEST]: (state) => ({
    ...state,
    loading: { ...state.loading, subscribe: true },
    error: { ...state.error, subscribe: null },
  }),
  [Types.SUBSCRIBE_SUCCESS]: (state) => ({
    ...state,
    loading: { ...state.loading, subscribe: false },
  }),
  [Types.SUBSCRIBE_FAILURE]: (state, { error }) => ({
    ...state,
    loading: { ...state.loading, subscribe: false },
    error: { ...state.error, subscribe: error },
  }),

  // CHECKOUT
  [Types.CHECKOUT_REQUEST]: (state) => ({
    ...state,
    loading: { ...state.loading, checkout: true },
    error: { ...state.error, checkout: null },
  }),
  [Types.CHECKOUT_SUCCESS]: (state) => ({
    ...state,
    loading: { ...state.loading, checkout: false },
  }),
  [Types.CHECKOUT_FAILURE]: (state, { error }) => ({
    ...state,
    loading: { ...state.loading, checkout: false },
    error: { ...state.error, checkout: error },
  }),

  // PROMO CODE
  [Types.VALIDATE_PROMO_CODE_REQUEST]: (state) => ({
    ...state,
    promoCode: { data: null, isValid: false },
    loading: { ...state.loading, promoCode: true },
    error: { ...state.error, promoCode: null },
  }),
  [Types.VALIDATE_PROMO_CODE_SUCCESS]: (state, { response }) => ({
    ...state,
    promoCode: { data: response, isValid: true },
    loading: { ...state.loading, promoCode: false },
  }),
  [Types.VALIDATE_PROMO_CODE_FAILURE]: (state, { error }) => ({
    ...state,
    promoCode: { data: null, isValid: false },
    loading: { ...state.loading, promoCode: false },
    error: { ...state.error, promoCode: error },
  }),
  [Types.CLEAR_PROMO_CODE]: (state) => ({
    ...state,
    promoCode: { data: null, isValid: false },
    error: { ...state.error, promoCode: null },
  }),
};

// ✅ EXPORT
export default createReducer(INITIAL_STATE, HANDLERS);
export { Types as types, Creators as actions };